// components/layouts/DashboardLayout.jsx
import React from 'react';
import Logo from '../common/Logo';
import PatientSidebar from '../dashboard-patient/PatientSidebar';
import PropTypes from 'prop-types';

const DashboardLayout = ({ children, helpText }) => {
  return (
    <div className="flex min-h-screen">
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <PatientSidebar />
        {helpText && (
          <div className="bottom-10 left-1/2 bg-purple-600 text-white p-4 rounded-lg shadow-lg w-10/12 mx-2.5">
            <h3 className="font-bold">Come funziona?</h3>
            <p className="text-sm">{helpText}</p>
          </div>
        )}
      </div>
      <div className="flex-1 p-8  bg-[#FAF4EB]">
        {children}
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  helpText: PropTypes.string
};

export default DashboardLayout;